// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  text-align: center;
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

.App-header {
  background-color: #6C6BAE;
  min-height: 13vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: 2.8vw;
  font-family: 'Roboto', sans-serif;
  font-weight: bold;
  color: white;
}

.body {
  background-color: #000000;
  height: 75vh;
  display: flex;
  flex-direction: row;
  /* align-items: center;
  justify-content: center; */
  color: white;
}

.body_left {
  position: relative;
  background-color: red;
  min-width: 50vw;
  display: flex;
  flex-direction: column;
  align-items: center; /* ตำแหน่งแนวนอน */
  justify-content: flex-start; /* ตำแหน่งแนวตั้ง */
  font-size: 2vw;
  font-family: 'Roboto', sans-serif;
  color: #2F343B;
}

.logo_box {
  position: absolute;
  background-color: #ffffff;
  top: 11%;
  left: 0%;
  width: 50%;
  height: 60%;
}

.graph_box_r {
  position: absolute;
  background-color: #0b9de6;
  top: 20%;
  left: 20%;
  width: 60%;
  height: 60%;
  display: flex;
  flex-direction: column;
  align-items: center; /* ตำแหน่งแนวนอน */
  justify-content: center; /* ตำแหน่งแนวตั้ง */
  z-index: 1;
  border: 0.2vh solid black;
}

.body_left_head {
  background-color: #ffffff;
  min-width: 50vw;
  min-height:61.5vh;
  overflow: auto;
  display: flex;
  flex-direction: column;
  align-items: center; /* ตำแหน่งแนวนอน */
  justify-content: flex-start; /* ตำแหน่งแนวตั้ง */
  color: #2F343B;
}

.body_left_bottom_r {
  position: absolute;
  top: 74.5%;
  left: 0%;
  background-color: #ffffff;
  width: 50vw;
  height:13.5vh;
  display: flex;
  flex-direction: column;
  align-items: center; /* ตำแหน่งแนวนอน */
  justify-content: flex-end; /* ตำแหน่งแนวตั้ง */
  color: #2F343B;
}

.body_left_right {
  position: absolute;
  background-color: #ffffff;
  top: 11%;
  left: 50%;
  width: 50%;
  height: 60%;
  display: flex;
  flex-direction: column;
  align-items: flex-start; /* ตำแหน่งแนวนอน */
  justify-content: center; /* ตำแหน่งแนวตั้ง */
  padding-left: 5%;
  font-size: 2vw;
  font-family: 'Roboto', sans-serif;
  font-weight: bold;
  color: #2F343B;
}

.login_box {
  position: absolute;
  background-color: #F3F7F9;
  top: 75%;
  left: 40%;
  width: 20%;
  height: 10%;
  display: flex;
  flex-direction: column;
  align-items: center; /* ตำแหน่งแนวนอน */
  justify-content: center; /* ตำแหน่งแนวตั้ง */
  font-size: 1.6vw;
  font-family: 'Roboto', sans-serif;
  color: #2F343B;
  border: 0.1vw solid #646464;
  border-radius: 2vw;
}

.red_box_r {
  position: absolute;
  background-color: rgb(255, 255, 255);
  top: 82%;
  left: 0%;
  width: 18%;
  height: 18%;
  display: flex;
  flex-direction: column;
  align-items: center; /* ตำแหน่งแนวนอน */
  justify-content: center; /* ตำแหน่งแนวตั้ง */
  font-size: 2vw;
  font-family: 'Roboto', sans-serif;
  font-weight: bold;
  color: #2F343B;
}

.green_box {
  position: absolute;
  background-color: green;
  top: 22%;
  left: 55%;
  width: 18%;
  height: 18%;
  display: flex;
  flex-direction: column;
  align-items: center; /* ตำแหน่งแนวนอน */
  justify-content: center; /* ตำแหน่งแนวตั้ง */
  font-size: 2vw;
  font-family: 'Roboto', sans-serif;
  font-weight: bold;
  color: #2F343B;
}

.body_right {
  position: relative; /* เมื่อกล่องใช้ absulote จะอ้างอิงตำแหน่งจาก div นี้แทน */
  background-color: #80e588;
  min-width: 50vw;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: 2vw;
  color: white;
}

.footer {
  background-color: #2F343B;
  height: 12vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: 1vw;
  color: white;
}

.back_r {
  position: absolute;
  background-color: #F3F7F9;
  top: 82vh;
  left: 1vw;
  width: 7vw;
  height: 5vh;
  display: flex;
  flex-direction: column;
  align-items: center; /* ตำแหน่งแนวนอน */
  justify-content: center; /* ตำแหน่งแนวตั้ง */
  font-size: 1vw;
  font-family: 'Roboto', sans-serif;
  color: #2F343B;
  border: 0.1vw solid #646464;
  border-radius: 0.5vw;
}

.box_row_1_1 {
  position: absolute; /* ลอย */
  top: 11%;
  left: 42%;
  width: 5%;
  height: 11%;
  background-color: black;
  border: 0.2vh solid black;
  transform: rotate(0deg);
  justify-content: center;
  align-items: center;
  color: white;
  font-size: 2vw;
  display: flex;
}

.box_row_1_2 {
  position: absolute; /* ลอย */
  top: 11%;
  left: 48%;
  width: 5%;
  height: 11%;
  background-color: black;
  border: 0.2vh solid black;
  transform: rotate(0deg);
  justify-content: center;
  align-items: center;
  color: white;
  font-size: 2vw;
  display: flex;
}

.box_row_1_3 {
  position: absolute; /* ลอย */
  top: 11%;
  left: 54%;
  width: 5%;
  height: 11%;
  background-color: black;
  border: 0.2vh solid black;
  transform: rotate(0deg);
  justify-content: center;
  align-items: center;
  color: white;
  font-size: 2vw;
  display: flex;
}

.box_row_1_4 {
  position: absolute; /* ลอย */
  top: 11%;
  left: 60%;
  width: 5%;
  height: 11%;
  background-color: black;
  border: 0.2vh solid black;
  transform: rotate(0deg);
  justify-content: center;
  align-items: center;
  color: white;
  font-size: 2vw;
  display: flex;
}

.box_row_2_1 {
  position: absolute; /* ลอย */
  top: 35%;
  left: 42%;
  width: 5%;
  height: 11%;
  background-color: black;
  border: 0.2vh solid black;
  transform: rotate(0deg);
  justify-content: center;
  align-items: center;
  color: white;
  font-size: 2vw;
  display: flex;
}

.box_row_2_2 {
  position: absolute; /* ลอย */
  top: 35%;
  left: 48%;
  width: 5%;
  height: 11%;
  background-color: black;
  border: 0.2vh solid black;
  transform: rotate(0deg);
  justify-content: center;
  align-items: center;
  color: white;
  font-size: 2vw;
  display: flex;
}

.box_row_2_3 {
  position: absolute; /* ลอย */
  top: 35%;
  left: 54%;
  width: 5%;
  height: 11%;
  background-color: black;
  border: 0.2vh solid black;
  transform: rotate(0deg);
  justify-content: center;
  align-items: center;
  color: white;
  font-size: 2vw;
  display: flex;
}

.box_row_2_4 {
  position: absolute; /* ลอย */
  top: 35%;
  left: 60%;
  width: 5%;
  height: 11%;
  background-color: black;
  border: 0.2vh solid black;
  transform: rotate(0deg);
  justify-content: center;
  align-items: center;
  color: white;
  font-size: 2vw;
  display: flex;
}

.box_row_3_1 {
  position: absolute; /* ลอย */
  top: 50%;
  left: 42%;
  width: 5%;
  height: 11%;
  background-color: black;
  border: 0.2vh solid black;
  transform: rotate(0deg);
  justify-content: center;
  align-items: center;
  color: white;
  font-size: 2vw;
  display: flex;
}

.box_row_3_2 {
  position: absolute; /* ลอย */
  top: 50%;
  left: 48%;
  width: 5%;
  height: 11%;
  background-color: black;
  border: 0.2vh solid black;
  transform: rotate(0deg);
  justify-content: center;
  align-items: center;
  color: white;
  font-size: 2vw;
  display: flex;
}

.box_row_3_3 {
  position: absolute; /* ลอย */
  top: 50%;
  left: 54%;
  width: 5%;
  height: 11%;
  background-color: black;
  border: 0.2vh solid black;
  transform: rotate(0deg);
  justify-content: center;
  align-items: center;
  color: white;
  font-size: 2vw;
  display: flex;
}

.box_row_3_4 {
  position: absolute; /* ลอย */
  top: 50%;
  left: 60%;
  width: 5%;
  height: 11%;
  background-color: black;
  border: 0.2vh solid black;
  transform: rotate(0deg);
  justify-content: center;
  align-items: center;
  color: white;
  font-size: 2vw;
  display: flex;
}

.box_row_4_1 {
  position: absolute; /* ลอย */
  top: 75%;
  left: 40%;
  width: 5%;
  height: 11%;
  background-color: black;
  border: 0.2vh solid black;
  transform: rotate(0deg);
  justify-content: center;
  align-items: center;
  color: white;
  font-size: 2vw;
  display: flex;
}

.box_row_4_2 {
  position: absolute; /* ลอย */
  top: 75%;
  left: 46%;
  width: 5%;
  height: 11%;
  background-color: black;
  border: 0.2vh solid black;
  transform: rotate(0deg);
  justify-content: center;
  align-items: center;
  color: white;
  font-size: 2vw;
  display: flex;
}

.box_row_4_3 {
  position: absolute; /* ลอย */
  top: 75%;
  left: 52%;
  width: 5%;
  height: 11%;
  background-color: black;
  border: 0.2vh solid black;
  transform: rotate(0deg);
  justify-content: center;
  align-items: center;
  color: white;
  font-size: 2vw;
  display: flex;
}

.box_row_4_4 {
  position: absolute; /* ลอย */
  top: 75%;
  left: 58%;
  width: 5%;
  height: 11%;
  background-color: black;
  border: 0.2vh solid black;
  transform: rotate(0deg);
  justify-content: center;
  align-items: center;
  color: white;
  font-size: 2vw;
  display: flex;
}

.box_row_4_5 {
  position: absolute; /* ลอย */
  top: 75%;
  left: 64%;
  width: 5%;
  height: 11%;
  background-color: black;
  border: 0.2vh solid black;
  transform: rotate(0deg);
  justify-content: center;
  align-items: center;
  color: white;
  font-size: 2vw;
  display: flex;
}

  .table_head {
    width: 95%;
    border-collapse: collapse;
    /* margin: 0 auto; ถ้าอยากให้อยู่กลาง div */
  }

  .table_stats {
    border-collapse: collapse;
    width: 50%;
    border: 0.3vh solid white;
    margin: 0 auto;
  }

  .cellStyle2_0 {
    font-family: 'TH Sarabun New, sans-serif';
    font-size: 1vw;
    color: #2F343B;
    /* background-color: #ffffff; */
    padding: 0.1vw;
    border: 1px solid #ffffff;
    text-align: left;
  }

  .cellStyle3 {
    font-family: 'Roboto', sans-serif;
    font-size: 1vw;
    color: #2F343B;
    /* background-color: #eeeeee; */
    padding: 0.1vw;
    border: 1px solid #ffffff;
    text-align: right;
  }

  .cellStyle {
    font-family: 'TH Sarabun New, sans-serif';
    font-size: 1.1vw;
    color: #2F343B;
    /* background-color: #eeeeee; */
    padding: 0.1vw;
    border: 1px solid #ffffff;
    text-align: center;
  }

  .cellStyle2 {
    font-family: 'TH Sarabun New, sans-serif';
    font-size: 1vw;
    padding: 0.1vw;
    border: 1px solid #ffffff;
  }

  .cellStyle2_date {
    font-family: 'TH Sarabun New, sans-serif';
    font-size: 1vw;
    padding: 0.1vw;
    border: 1px solid #ffffff;
  }

  .A_label {
  position: absolute; /* ลอย */
  top: 7vh;
  left: 16vw;
  width: 5%;
  height: 11%;
  color: white;
  font-size: 3.5vw;
  display: flex;
  }

  .A_label {
  position: absolute; /* ลอย */
  top: 7vh;
  left: 16vw;
  width: 5%;
  height: 11%;
  color: white;
  font-size: 3.5vw;
  display: flex;
  }

  .B_label {
  position: absolute; /* ลอย */
  top: 25.5vh;
  left: 16vw;
  width: 5%;
  height: 11%;
  color: white;
  font-size: 3.5vw;
  display: flex;
  }

  .C_label {
  position: absolute; /* ลอย */
  top: 36.5vh;
  left: 16vw;
  width: 5%;
  height: 11%;
  color: white;
  font-size: 3.5vw;
  display: flex;
  }

  .D_label {
  position: absolute; /* ลอย */
  top: 55.5vh;
  left: 16vw;
  width: 5%;
  height: 11%;
  color: white;
  font-size: 3.5vw;
  display: flex;
  }

.App-link {
  color: #61dafb;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

@media (max-width: 768px) {
  .body {
    background-color: #000000;
    flex-grow: 1;
    height: auto !important;
    /* min-height: vh; */
    display: flex;
    flex-direction: column !important;
  }

  .body_left {
    width: 100% ;
    height: 40vh ;
    /* min-height: 45vh ; */
    position: relative;
  }

  .body_right {
    width: 100% ;
    height: 50vh ;
    /* min-height: 40vh ; */
    position: relative;
  }

  .body_left_head {
    background-color: #ffffff;
    min-width: 100vw;
    min-height:60vh;
    overflow: auto;
    display: flex;
    flex-direction: column;
    align-items: center; /* ตำแหน่งแนวนอน */
    justify-content: flex-start; /* ตำแหน่งแนวตั้ง */
    color: #2F343B;
  }

    .App-header {
    background-color: #6C6BAE;
    min-height: 10vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    font-size: 3.8vh;
    font-family: 'Roboto', sans-serif;
    font-weight: bold;
    color: white;
  }

  .body_left_bottom_r {
    position: relative;
    /* top: 62.5%;
    left: 0%; */
    background-color: #ffffff;
    width: 100vw;
    height:15vh;
    display: flex;
    flex-direction: column;
    align-items: center; /* ตำแหน่งแนวนอน */
    justify-content: center; /* ตำแหน่งแนวตั้ง */
    color: #2F343B;
    /* z-index: 1; */
  }

  .back_r {
    position: absolute;
    background-color: #ffffff;
    top: 59vh;
    left: 0.1vw;
    width: 15vw;
    height: 5vh;
    display: flex;
    flex-direction: column;
    align-items: center; /* ตำแหน่งแนวนอน */
    justify-content: center; /* ตำแหน่งแนวตั้ง */
    font-size: 2vh;
    font-family: 'Roboto', sans-serif;
    color: #2F343B;
    border: 0.1vh solid #646464;
    border-radius: 1vh;
    z-index: 1;
  }

  .table_head {
    width: 95%;
    /* height: 50%; */
    border-collapse: collapse;
    /* margin: 0 auto; ถ้าอยากให้อยู่กลาง div */
  }

  .table_stats {
    border-collapse: collapse;
    width: 70%;
    height: 70%;
    /* border: 0.3vh solid white; */
    /* margin: 0 auto; */
  }

  .cellStyle2_0 {
    font-family: 'Roboto', sans-serif;
    font-size: 2vh;
    color: #2F343B;
    /* background-color: #ffffff; */
    padding: 0;
    border: 0.1vh solid #ffffff;
    text-align: left;
  }

  .cellStyle3 {
    font-family: 'Roboto', sans-serif;
    font-size: 2vh;
    color: #2F343B;
    /* background-color: #eeeeee; */
    padding: 0;
    border: 0.1vh solid #ffffff;
    text-align: right;
  }

  .cellStyle {
    font-family: 'TH Sarabun New, sans-serif';
    font-size: 2vh;
    color: #2F343B;
    padding: 0;
    /* border: 0.1vh solid #ffffff; */
    text-align: center;
  }

  .cellStyle2 {
    font-family: 'Roboto', sans-serif;
    font-size: 2vh;
    color: #2F343B;
    /* background-color: #eeeeee; */
    padding: 0;
    border: 0.1vh solid #ffffff;
    text-align: right;
  }

  .cellStyle2_date {
    font-family: 'Roboto', sans-serif;
    font-size: 2vh;
    color: #2F343B;
    /* background-color: #eeeeee; */
    padding: 0;
    border: 0.1vh solid #ffffff;
    text-align: right;
  }

  .footer {
    background-color: #2F343B;
    height: 12vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    font-size: 1.4vh;
    color: white;
    /* position: relative; */
  }

  .A_label {
  position: absolute; /* ลอย */
  top: 6.5vh;
  left: 32vw;
  width: 5%;
  height: 11%;
  color: white;
  font-size: 3.5vw;
  display: flex;
  }

  .B_label {
  position: absolute; /* ลอย */
  top: 18.5vh;
  left: 32vw;
  width: 5%;
  height: 11%;
  color: white;
  font-size: 3.5vw;
  display: flex;
  }

  .C_label {
  position: absolute; /* ลอย */
  top: 26.5vh;
  left: 32vw;
  width: 5%;
  height: 11%;
  color: white;
  font-size: 3.5vw;
  display: flex;
  }

  .D_label {
  position: absolute; /* ลอย */
  top: 38.5vh;
  left: 32vw;
  width: 5%;
  height: 11%;
  color: white;
  font-size: 3.5vw;
  display: flex;
  }
}`, "",{"version":3,"sources":["webpack://./src/registered.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,iCAAiC;EACjC,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB;4BAC0B;EAC1B,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,mBAAmB,EAAE,kBAAkB;EACvC,2BAA2B,EAAE,mBAAmB;EAChD,cAAc;EACd,iCAAiC;EACjC,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,QAAQ;EACR,QAAQ;EACR,UAAU;EACV,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,QAAQ;EACR,SAAS;EACT,UAAU;EACV,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mBAAmB,EAAE,kBAAkB;EACvC,uBAAuB,EAAE,mBAAmB;EAC5C,UAAU;EACV,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,mBAAmB,EAAE,kBAAkB;EACvC,2BAA2B,EAAE,mBAAmB;EAChD,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,yBAAyB;EACzB,WAAW;EACX,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,mBAAmB,EAAE,kBAAkB;EACvC,yBAAyB,EAAE,mBAAmB;EAC9C,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,QAAQ;EACR,SAAS;EACT,UAAU;EACV,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,uBAAuB,EAAE,kBAAkB;EAC3C,uBAAuB,EAAE,mBAAmB;EAC5C,gBAAgB;EAChB,cAAc;EACd,iCAAiC;EACjC,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,QAAQ;EACR,SAAS;EACT,UAAU;EACV,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mBAAmB,EAAE,kBAAkB;EACvC,uBAAuB,EAAE,mBAAmB;EAC5C,gBAAgB;EAChB,iCAAiC;EACjC,cAAc;EACd,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,oCAAoC;EACpC,QAAQ;EACR,QAAQ;EACR,UAAU;EACV,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mBAAmB,EAAE,kBAAkB;EACvC,uBAAuB,EAAE,mBAAmB;EAC5C,cAAc;EACd,iCAAiC;EACjC,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,QAAQ;EACR,SAAS;EACT,UAAU;EACV,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mBAAmB,EAAE,kBAAkB;EACvC,uBAAuB,EAAE,mBAAmB;EAC5C,cAAc;EACd,iCAAiC;EACjC,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB,EAAE,0DAA0D;EAC9E,yBAAyB;EACzB,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,SAAS;EACT,SAAS;EACT,UAAU;EACV,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mBAAmB,EAAE,kBAAkB;EACvC,uBAAuB,EAAE,mBAAmB;EAC5C,cAAc;EACd,iCAAiC;EACjC,cAAc;EACd,2BAA2B;EAC3B,oBAAoB;AACtB;;AAEA;EACE,kBAAkB,EAAE,QAAQ;EAC5B,QAAQ;EACR,SAAS;EACT,SAAS;EACT,WAAW;EACX,uBAAuB;EACvB,yBAAyB;EACzB,uBAAuB;EACvB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,aAAa;AACf;;AAEA;EACE,kBAAkB,EAAE,QAAQ;EAC5B,QAAQ;EACR,SAAS;EACT,SAAS;EACT,WAAW;EACX,uBAAuB;EACvB,yBAAyB;EACzB,uBAAuB;EACvB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,aAAa;AACf;;AAEA;EACE,kBAAkB,EAAE,QAAQ;EAC5B,QAAQ;EACR,SAAS;EACT,SAAS;EACT,WAAW;EACX,uBAAuB;EACvB,yBAAyB;EACzB,uBAAuB;EACvB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,aAAa;AACf;;AAEA;EACE,kBAAkB,EAAE,QAAQ;EAC5B,QAAQ;EACR,SAAS;EACT,SAAS;EACT,WAAW;EACX,uBAAuB;EACvB,yBAAyB;EACzB,uBAAuB;EACvB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,aAAa;AACf;;AAEA;EACE,kBAAkB,EAAE,QAAQ;EAC5B,QAAQ;EACR,SAAS;EACT,SAAS;EACT,WAAW;EACX,uBAAuB;EACvB,yBAAyB;EACzB,uBAAuB;EACvB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,aAAa;AACf;;AAEA;EACE,kBAAkB,EAAE,QAAQ;EAC5B,QAAQ;EACR,SAAS;EACT,SAAS;EACT,WAAW;EACX,uBAAuB;EACvB,yBAAyB;EACzB,uBAAuB;EACvB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,aAAa;AACf;;AAEA;EACE,kBAAkB,EAAE,QAAQ;EAC5B,QAAQ;EACR,SAAS;EACT,SAAS;EACT,WAAW;EACX,uBAAuB;EACvB,yBAAyB;EACzB,uBAAuB;EACvB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,aAAa;AACf;;AAEA;EACE,kBAAkB,EAAE,QAAQ;EAC5B,QAAQ;EACR,SAAS;EACT,SAAS;EACT,WAAW;EACX,uBAAuB;EACvB,yBAAyB;EACzB,uBAAuB;EACvB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,aAAa;AACf;;AAEA;EACE,kBAAkB,EAAE,QAAQ;EAC5B,QAAQ;EACR,SAAS;EACT,SAAS;EACT,WAAW;EACX,uBAAuB;EACvB,yBAAyB;EACzB,uBAAuB;EACvB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,aAAa;AACf;;AAEA;EACE,kBAAkB,EAAE,QAAQ;EAC5B,QAAQ;EACR,SAAS;EACT,SAAS;EACT,WAAW;EACX,uBAAuB;EACvB,yBAAyB;EACzB,uBAAuB;EACvB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,aAAa;AACf;;AAEA;EACE,kBAAkB,EAAE,QAAQ;EAC5B,QAAQ;EACR,SAAS;EACT,SAAS;EACT,WAAW;EACX,uBAAuB;EACvB,yBAAyB;EACzB,uBAAuB;EACvB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,aAAa;AACf;;AAEA;EACE,kBAAkB,EAAE,QAAQ;EAC5B,QAAQ;EACR,SAAS;EACT,SAAS;EACT,WAAW;EACX,uBAAuB;EACvB,yBAAyB;EACzB,uBAAuB;EACvB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,aAAa;AACf;;AAEA;EACE,kBAAkB,EAAE,QAAQ;EAC5B,QAAQ;EACR,SAAS;EACT,SAAS;EACT,WAAW;EACX,uBAAuB;EACvB,yBAAyB;EACzB,uBAAuB;EACvB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,aAAa;AACf;;AAEA;EACE,kBAAkB,EAAE,QAAQ;EAC5B,QAAQ;EACR,SAAS;EACT,SAAS;EACT,WAAW;EACX,uBAAuB;EACvB,yBAAyB;EACzB,uBAAuB;EACvB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,aAAa;AACf;;AAEA;EACE,kBAAkB,EAAE,QAAQ;EAC5B,QAAQ;EACR,SAAS;EACT,SAAS;EACT,WAAW;EACX,uBAAuB;EACvB,yBAAyB;EACzB,uBAAuB;EACvB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,aAAa;AACf;;AAEA;EACE,kBAAkB,EAAE,QAAQ;EAC5B,QAAQ;EACR,SAAS;EACT,SAAS;EACT,WAAW;EACX,uBAAuB;EACvB,yBAAyB;EACzB,uBAAuB;EACvB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,aAAa;AACf;;AAEA;EACE,kBAAkB,EAAE,QAAQ;EAC5B,QAAQ;EACR,SAAS;EACT,SAAS;EACT,WAAW;EACX,uBAAuB;EACvB,yBAAyB;EACzB,uBAAuB;EACvB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,aAAa;AACf;;EAEE;IACE,UAAU;IACV,yBAAyB;IACzB,2CAA2C;EAC7C;;EAEA;IACE,yBAAyB;IACzB,UAAU;IACV,yBAAyB;IACzB,cAAc;EAChB;;EAEA;IACE,yCAAyC;IACzC,cAAc;IACd,cAAc;IACd,+BAA+B;IAC/B,cAAc;IACd,yBAAyB;IACzB,gBAAgB;EAClB;;EAEA;IACE,iCAAiC;IACjC,cAAc;IACd,cAAc;IACd,+BAA+B;IAC/B,cAAc;IACd,yBAAyB;IACzB,iBAAiB;EACnB;;EAEA;IACE,yCAAyC;IACzC,gBAAgB;IAChB,cAAc;IACd,+BAA+B;IAC/B,cAAc;IACd,yBAAyB;IACzB,kBAAkB;EACpB;;EAEA;IACE,yCAAyC;IACzC,cAAc;IACd,cAAc;IACd,yBAAyB;EAC3B;;EAEA;IACE,yCAAyC;IACzC,cAAc;IACd,cAAc;IACd,yBAAyB;EAC3B;;EAEA;EACA,kBAAkB,EAAE,QAAQ;EAC5B,QAAQ;EACR,UAAU;EACV,SAAS;EACT,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb;;EAEA;EACA,kBAAkB,EAAE,QAAQ;EAC5B,QAAQ;EACR,UAAU;EACV,SAAS;EACT,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb;;EAEA;EACA,kBAAkB,EAAE,QAAQ;EAC5B,WAAW;EACX,UAAU;EACV,SAAS;EACT,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb;;EAEA;EACA,kBAAkB,EAAE,QAAQ;EAC5B,WAAW;EACX,UAAU;EACV,SAAS;EACT,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb;;EAEA;EACA,kBAAkB,EAAE,QAAQ;EAC5B,WAAW;EACX,UAAU;EACV,SAAS;EACT,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb;;AAEF;EACE,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,yBAAyB;IACzB,YAAY;IACZ,uBAAuB;IACvB,oBAAoB;IACpB,aAAa;IACb,iCAAiC;EACnC;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,kBAAkB;EACpB;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,kBAAkB;EACpB;;EAEA;IACE,yBAAyB;IACzB,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,aAAa;IACb,sBAAsB;IACtB,mBAAmB,EAAE,kBAAkB;IACvC,2BAA2B,EAAE,mBAAmB;IAChD,cAAc;EAChB;;IAEE;IACA,yBAAyB;IACzB,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,iCAAiC;IACjC,iBAAiB;IACjB,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB;eACW;IACX,yBAAyB;IACzB,YAAY;IACZ,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,mBAAmB,EAAE,kBAAkB;IACvC,uBAAuB,EAAE,mBAAmB;IAC5C,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,yBAAyB;IACzB,SAAS;IACT,WAAW;IACX,WAAW;IACX,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,mBAAmB,EAAE,kBAAkB;IACvC,uBAAuB,EAAE,mBAAmB;IAC5C,cAAc;IACd,iCAAiC;IACjC,cAAc;IACd,2BAA2B;IAC3B,kBAAkB;IAClB,UAAU;EACZ;;EAEA;IACE,UAAU;IACV,iBAAiB;IACjB,yBAAyB;IACzB,2CAA2C;EAC7C;;EAEA;IACE,yBAAyB;IACzB,UAAU;IACV,WAAW;IACX,+BAA+B;IAC/B,oBAAoB;EACtB;;EAEA;IACE,iCAAiC;IACjC,cAAc;IACd,cAAc;IACd,+BAA+B;IAC/B,UAAU;IACV,2BAA2B;IAC3B,gBAAgB;EAClB;;EAEA;IACE,iCAAiC;IACjC,cAAc;IACd,cAAc;IACd,+BAA+B;IAC/B,UAAU;IACV,2BAA2B;IAC3B,iBAAiB;EACnB;;EAEA;IACE,yCAAyC;IACzC,cAAc;IACd,cAAc;IACd,UAAU;IACV,iCAAiC;IACjC,kBAAkB;EACpB;;EAEA;IACE,iCAAiC;IACjC,cAAc;IACd,cAAc;IACd,+BAA+B;IAC/B,UAAU;IACV,2BAA2B;IAC3B,iBAAiB;EACnB;;EAEA;IACE,iCAAiC;IACjC,cAAc;IACd,cAAc;IACd,+BAA+B;IAC/B,UAAU;IACV,2BAA2B;IAC3B,iBAAiB;EACnB;;EAEA;IACE,yBAAyB;IACzB,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,YAAY;IACZ,wBAAwB;EAC1B;;EAEA;EACA,kBAAkB,EAAE,QAAQ;EAC5B,UAAU;EACV,UAAU;EACV,SAAS;EACT,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb;;EAEA;EACA,kBAAkB,EAAE,QAAQ;EAC5B,WAAW;EACX,UAAU;EACV,SAAS;EACT,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb;;EAEA;EACA,kBAAkB,EAAE,QAAQ;EAC5B,WAAW;EACX,UAAU;EACV,SAAS;EACT,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb;;EAEA;EACA,kBAAkB,EAAE,QAAQ;EAC5B,WAAW;EACX,UAAU;EACV,SAAS;EACT,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb;AACF","sourcesContent":[".App {\n  text-align: center;\n}\n\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n\n.App-header {\n  background-color: #6C6BAE;\n  min-height: 13vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: 2.8vw;\n  font-family: 'Roboto', sans-serif;\n  font-weight: bold;\n  color: white;\n}\n\n.body {\n  background-color: #000000;\n  height: 75vh;\n  display: flex;\n  flex-direction: row;\n  /* align-items: center;\n  justify-content: center; */\n  color: white;\n}\n\n.body_left {\n  position: relative;\n  background-color: red;\n  min-width: 50vw;\n  display: flex;\n  flex-direction: column;\n  align-items: center; /* ตำแหน่งแนวนอน */\n  justify-content: flex-start; /* ตำแหน่งแนวตั้ง */\n  font-size: 2vw;\n  font-family: 'Roboto', sans-serif;\n  color: #2F343B;\n}\n\n.logo_box {\n  position: absolute;\n  background-color: #ffffff;\n  top: 11%;\n  left: 0%;\n  width: 50%;\n  height: 60%;\n}\n\n.graph_box_r {\n  position: absolute;\n  background-color: #0b9de6;\n  top: 20%;\n  left: 20%;\n  width: 60%;\n  height: 60%;\n  display: flex;\n  flex-direction: column;\n  align-items: center; /* ตำแหน่งแนวนอน */\n  justify-content: center; /* ตำแหน่งแนวตั้ง */\n  z-index: 1;\n  border: 0.2vh solid black;\n}\n\n.body_left_head {\n  background-color: #ffffff;\n  min-width: 50vw;\n  min-height:61.5vh;\n  overflow: auto;\n  display: flex;\n  flex-direction: column;\n  align-items: center; /* ตำแหน่งแนวนอน */\n  justify-content: flex-start; /* ตำแหน่งแนวตั้ง */\n  color: #2F343B;\n}\n\n.body_left_bottom_r {\n  position: absolute;\n  top: 74.5%;\n  left: 0%;\n  background-color: #ffffff;\n  width: 50vw;\n  height:13.5vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center; /* ตำแหน่งแนวนอน */\n  justify-content: flex-end; /* ตำแหน่งแนวตั้ง */\n  color: #2F343B;\n}\n\n.body_left_right {\n  position: absolute;\n  background-color: #ffffff;\n  top: 11%;\n  left: 50%;\n  width: 50%;\n  height: 60%;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start; /* ตำแหน่งแนวนอน */\n  justify-content: center; /* ตำแหน่งแนวตั้ง */\n  padding-left: 5%;\n  font-size: 2vw;\n  font-family: 'Roboto', sans-serif;\n  font-weight: bold;\n  color: #2F343B;\n}\n\n.login_box {\n  position: absolute;\n  background-color: #F3F7F9;\n  top: 75%;\n  left: 40%;\n  width: 20%;\n  height: 10%;\n  display: flex;\n  flex-direction: column;\n  align-items: center; /* ตำแหน่งแนวนอน */\n  justify-content: center; /* ตำแหน่งแนวตั้ง */\n  font-size: 1.6vw;\n  font-family: 'Roboto', sans-serif;\n  color: #2F343B;\n  border: 0.1vw solid #646464;\n  border-radius: 2vw;\n}\n\n.red_box_r {\n  position: absolute;\n  background-color: rgb(255, 255, 255);\n  top: 82%;\n  left: 0%;\n  width: 18%;\n  height: 18%;\n  display: flex;\n  flex-direction: column;\n  align-items: center; /* ตำแหน่งแนวนอน */\n  justify-content: center; /* ตำแหน่งแนวตั้ง */\n  font-size: 2vw;\n  font-family: 'Roboto', sans-serif;\n  font-weight: bold;\n  color: #2F343B;\n}\n\n.green_box {\n  position: absolute;\n  background-color: green;\n  top: 22%;\n  left: 55%;\n  width: 18%;\n  height: 18%;\n  display: flex;\n  flex-direction: column;\n  align-items: center; /* ตำแหน่งแนวนอน */\n  justify-content: center; /* ตำแหน่งแนวตั้ง */\n  font-size: 2vw;\n  font-family: 'Roboto', sans-serif;\n  font-weight: bold;\n  color: #2F343B;\n}\n\n.body_right {\n  position: relative; /* เมื่อกล่องใช้ absulote จะอ้างอิงตำแหน่งจาก div นี้แทน */\n  background-color: #80e588;\n  min-width: 50vw;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: 2vw;\n  color: white;\n}\n\n.footer {\n  background-color: #2F343B;\n  height: 12vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: 1vw;\n  color: white;\n}\n\n.back_r {\n  position: absolute;\n  background-color: #F3F7F9;\n  top: 82vh;\n  left: 1vw;\n  width: 7vw;\n  height: 5vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center; /* ตำแหน่งแนวนอน */\n  justify-content: center; /* ตำแหน่งแนวตั้ง */\n  font-size: 1vw;\n  font-family: 'Roboto', sans-serif;\n  color: #2F343B;\n  border: 0.1vw solid #646464;\n  border-radius: 0.5vw;\n}\n\n.box_row_1_1 {\n  position: absolute; /* ลอย */\n  top: 11%;\n  left: 42%;\n  width: 5%;\n  height: 11%;\n  background-color: black;\n  border: 0.2vh solid black;\n  transform: rotate(0deg);\n  justify-content: center;\n  align-items: center;\n  color: white;\n  font-size: 2vw;\n  display: flex;\n}\n\n.box_row_1_2 {\n  position: absolute; /* ลอย */\n  top: 11%;\n  left: 48%;\n  width: 5%;\n  height: 11%;\n  background-color: black;\n  border: 0.2vh solid black;\n  transform: rotate(0deg);\n  justify-content: center;\n  align-items: center;\n  color: white;\n  font-size: 2vw;\n  display: flex;\n}\n\n.box_row_1_3 {\n  position: absolute; /* ลอย */\n  top: 11%;\n  left: 54%;\n  width: 5%;\n  height: 11%;\n  background-color: black;\n  border: 0.2vh solid black;\n  transform: rotate(0deg);\n  justify-content: center;\n  align-items: center;\n  color: white;\n  font-size: 2vw;\n  display: flex;\n}\n\n.box_row_1_4 {\n  position: absolute; /* ลอย */\n  top: 11%;\n  left: 60%;\n  width: 5%;\n  height: 11%;\n  background-color: black;\n  border: 0.2vh solid black;\n  transform: rotate(0deg);\n  justify-content: center;\n  align-items: center;\n  color: white;\n  font-size: 2vw;\n  display: flex;\n}\n\n.box_row_2_1 {\n  position: absolute; /* ลอย */\n  top: 35%;\n  left: 42%;\n  width: 5%;\n  height: 11%;\n  background-color: black;\n  border: 0.2vh solid black;\n  transform: rotate(0deg);\n  justify-content: center;\n  align-items: center;\n  color: white;\n  font-size: 2vw;\n  display: flex;\n}\n\n.box_row_2_2 {\n  position: absolute; /* ลอย */\n  top: 35%;\n  left: 48%;\n  width: 5%;\n  height: 11%;\n  background-color: black;\n  border: 0.2vh solid black;\n  transform: rotate(0deg);\n  justify-content: center;\n  align-items: center;\n  color: white;\n  font-size: 2vw;\n  display: flex;\n}\n\n.box_row_2_3 {\n  position: absolute; /* ลอย */\n  top: 35%;\n  left: 54%;\n  width: 5%;\n  height: 11%;\n  background-color: black;\n  border: 0.2vh solid black;\n  transform: rotate(0deg);\n  justify-content: center;\n  align-items: center;\n  color: white;\n  font-size: 2vw;\n  display: flex;\n}\n\n.box_row_2_4 {\n  position: absolute; /* ลอย */\n  top: 35%;\n  left: 60%;\n  width: 5%;\n  height: 11%;\n  background-color: black;\n  border: 0.2vh solid black;\n  transform: rotate(0deg);\n  justify-content: center;\n  align-items: center;\n  color: white;\n  font-size: 2vw;\n  display: flex;\n}\n\n.box_row_3_1 {\n  position: absolute; /* ลอย */\n  top: 50%;\n  left: 42%;\n  width: 5%;\n  height: 11%;\n  background-color: black;\n  border: 0.2vh solid black;\n  transform: rotate(0deg);\n  justify-content: center;\n  align-items: center;\n  color: white;\n  font-size: 2vw;\n  display: flex;\n}\n\n.box_row_3_2 {\n  position: absolute; /* ลอย */\n  top: 50%;\n  left: 48%;\n  width: 5%;\n  height: 11%;\n  background-color: black;\n  border: 0.2vh solid black;\n  transform: rotate(0deg);\n  justify-content: center;\n  align-items: center;\n  color: white;\n  font-size: 2vw;\n  display: flex;\n}\n\n.box_row_3_3 {\n  position: absolute; /* ลอย */\n  top: 50%;\n  left: 54%;\n  width: 5%;\n  height: 11%;\n  background-color: black;\n  border: 0.2vh solid black;\n  transform: rotate(0deg);\n  justify-content: center;\n  align-items: center;\n  color: white;\n  font-size: 2vw;\n  display: flex;\n}\n\n.box_row_3_4 {\n  position: absolute; /* ลอย */\n  top: 50%;\n  left: 60%;\n  width: 5%;\n  height: 11%;\n  background-color: black;\n  border: 0.2vh solid black;\n  transform: rotate(0deg);\n  justify-content: center;\n  align-items: center;\n  color: white;\n  font-size: 2vw;\n  display: flex;\n}\n\n.box_row_4_1 {\n  position: absolute; /* ลอย */\n  top: 75%;\n  left: 40%;\n  width: 5%;\n  height: 11%;\n  background-color: black;\n  border: 0.2vh solid black;\n  transform: rotate(0deg);\n  justify-content: center;\n  align-items: center;\n  color: white;\n  font-size: 2vw;\n  display: flex;\n}\n\n.box_row_4_2 {\n  position: absolute; /* ลอย */\n  top: 75%;\n  left: 46%;\n  width: 5%;\n  height: 11%;\n  background-color: black;\n  border: 0.2vh solid black;\n  transform: rotate(0deg);\n  justify-content: center;\n  align-items: center;\n  color: white;\n  font-size: 2vw;\n  display: flex;\n}\n\n.box_row_4_3 {\n  position: absolute; /* ลอย */\n  top: 75%;\n  left: 52%;\n  width: 5%;\n  height: 11%;\n  background-color: black;\n  border: 0.2vh solid black;\n  transform: rotate(0deg);\n  justify-content: center;\n  align-items: center;\n  color: white;\n  font-size: 2vw;\n  display: flex;\n}\n\n.box_row_4_4 {\n  position: absolute; /* ลอย */\n  top: 75%;\n  left: 58%;\n  width: 5%;\n  height: 11%;\n  background-color: black;\n  border: 0.2vh solid black;\n  transform: rotate(0deg);\n  justify-content: center;\n  align-items: center;\n  color: white;\n  font-size: 2vw;\n  display: flex;\n}\n\n.box_row_4_5 {\n  position: absolute; /* ลอย */\n  top: 75%;\n  left: 64%;\n  width: 5%;\n  height: 11%;\n  background-color: black;\n  border: 0.2vh solid black;\n  transform: rotate(0deg);\n  justify-content: center;\n  align-items: center;\n  color: white;\n  font-size: 2vw;\n  display: flex;\n}\n\n  .table_head {\n    width: 95%;\n    border-collapse: collapse;\n    /* margin: 0 auto; ถ้าอยากให้อยู่กลาง div */\n  }\n\n  .table_stats {\n    border-collapse: collapse;\n    width: 50%;\n    border: 0.3vh solid white;\n    margin: 0 auto;\n  }\n\n  .cellStyle2_0 {\n    font-family: 'TH Sarabun New, sans-serif';\n    font-size: 1vw;\n    color: #2F343B;\n    /* background-color: #ffffff; */\n    padding: 0.1vw;\n    border: 1px solid #ffffff;\n    text-align: left;\n  }\n\n  .cellStyle3 {\n    font-family: 'Roboto', sans-serif;\n    font-size: 1vw;\n    color: #2F343B;\n    /* background-color: #eeeeee; */\n    padding: 0.1vw;\n    border: 1px solid #ffffff;\n    text-align: right;\n  }\n\n  .cellStyle {\n    font-family: 'TH Sarabun New, sans-serif';\n    font-size: 1.1vw;\n    color: #2F343B;\n    /* background-color: #eeeeee; */\n    padding: 0.1vw;\n    border: 1px solid #ffffff;\n    text-align: center;\n  }\n\n  .cellStyle2 {\n    font-family: 'TH Sarabun New, sans-serif';\n    font-size: 1vw;\n    padding: 0.1vw;\n    border: 1px solid #ffffff;\n  }\n\n  .cellStyle2_date {\n    font-family: 'TH Sarabun New, sans-serif';\n    font-size: 1vw;\n    padding: 0.1vw;\n    border: 1px solid #ffffff;\n  }\n\n  .A_label {\n  position: absolute; /* ลอย */\n  top: 7vh;\n  left: 16vw;\n  width: 5%;\n  height: 11%;\n  color: white;\n  font-size: 3.5vw;\n  display: flex;\n  }\n\n  .A_label {\n  position: absolute; /* ลอย */\n  top: 7vh;\n  left: 16vw;\n  width: 5%;\n  height: 11%;\n  color: white;\n  font-size: 3.5vw;\n  display: flex;\n  }\n\n  .B_label {\n  position: absolute; /* ลอย */\n  top: 25.5vh;\n  left: 16vw;\n  width: 5%;\n  height: 11%;\n  color: white;\n  font-size: 3.5vw;\n  display: flex;\n  }\n\n  .C_label {\n  position: absolute; /* ลอย */\n  top: 36.5vh;\n  left: 16vw;\n  width: 5%;\n  height: 11%;\n  color: white;\n  font-size: 3.5vw;\n  display: flex;\n  }\n\n  .D_label {\n  position: absolute; /* ลอย */\n  top: 55.5vh;\n  left: 16vw;\n  width: 5%;\n  height: 11%;\n  color: white;\n  font-size: 3.5vw;\n  display: flex;\n  }\n\n.App-link {\n  color: #61dafb;\n}\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n@media (max-width: 768px) {\n  .body {\n    background-color: #000000;\n    flex-grow: 1;\n    height: auto !important;\n    /* min-height: vh; */\n    display: flex;\n    flex-direction: column !important;\n  }\n\n  .body_left {\n    width: 100% ;\n    height: 40vh ;\n    /* min-height: 45vh ; */\n    position: relative;\n  }\n\n  .body_right {\n    width: 100% ;\n    height: 50vh ;\n    /* min-height: 40vh ; */\n    position: relative;\n  }\n\n  .body_left_head {\n    background-color: #ffffff;\n    min-width: 100vw;\n    min-height:60vh;\n    overflow: auto;\n    display: flex;\n    flex-direction: column;\n    align-items: center; /* ตำแหน่งแนวนอน */\n    justify-content: flex-start; /* ตำแหน่งแนวตั้ง */\n    color: #2F343B;\n  }\n\n    .App-header {\n    background-color: #6C6BAE;\n    min-height: 10vh;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    font-size: 3.8vh;\n    font-family: 'Roboto', sans-serif;\n    font-weight: bold;\n    color: white;\n  }\n\n  .body_left_bottom_r {\n    position: relative;\n    /* top: 62.5%;\n    left: 0%; */\n    background-color: #ffffff;\n    width: 100vw;\n    height:15vh;\n    display: flex;\n    flex-direction: column;\n    align-items: center; /* ตำแหน่งแนวนอน */\n    justify-content: center; /* ตำแหน่งแนวตั้ง */\n    color: #2F343B;\n    /* z-index: 1; */\n  }\n\n  .back_r {\n    position: absolute;\n    background-color: #ffffff;\n    top: 59vh;\n    left: 0.1vw;\n    width: 15vw;\n    height: 5vh;\n    display: flex;\n    flex-direction: column;\n    align-items: center; /* ตำแหน่งแนวนอน */\n    justify-content: center; /* ตำแหน่งแนวตั้ง */\n    font-size: 2vh;\n    font-family: 'Roboto', sans-serif;\n    color: #2F343B;\n    border: 0.1vh solid #646464;\n    border-radius: 1vh;\n    z-index: 1;\n  }\n\n  .table_head {\n    width: 95%;\n    /* height: 50%; */\n    border-collapse: collapse;\n    /* margin: 0 auto; ถ้าอยากให้อยู่กลาง div */\n  }\n\n  .table_stats {\n    border-collapse: collapse;\n    width: 70%;\n    height: 70%;\n    /* border: 0.3vh solid white; */\n    /* margin: 0 auto; */\n  }\n\n  .cellStyle2_0 {\n    font-family: 'Roboto', sans-serif;\n    font-size: 2vh;\n    color: #2F343B;\n    /* background-color: #ffffff; */\n    padding: 0;\n    border: 0.1vh solid #ffffff;\n    text-align: left;\n  }\n\n  .cellStyle3 {\n    font-family: 'Roboto', sans-serif;\n    font-size: 2vh;\n    color: #2F343B;\n    /* background-color: #eeeeee; */\n    padding: 0;\n    border: 0.1vh solid #ffffff;\n    text-align: right;\n  }\n\n  .cellStyle {\n    font-family: 'TH Sarabun New, sans-serif';\n    font-size: 2vh;\n    color: #2F343B;\n    padding: 0;\n    /* border: 0.1vh solid #ffffff; */\n    text-align: center;\n  }\n\n  .cellStyle2 {\n    font-family: 'Roboto', sans-serif;\n    font-size: 2vh;\n    color: #2F343B;\n    /* background-color: #eeeeee; */\n    padding: 0;\n    border: 0.1vh solid #ffffff;\n    text-align: right;\n  }\n\n  .cellStyle2_date {\n    font-family: 'Roboto', sans-serif;\n    font-size: 2vh;\n    color: #2F343B;\n    /* background-color: #eeeeee; */\n    padding: 0;\n    border: 0.1vh solid #ffffff;\n    text-align: right;\n  }\n\n  .footer {\n    background-color: #2F343B;\n    height: 12vh;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    font-size: 1.4vh;\n    color: white;\n    /* position: relative; */\n  }\n\n  .A_label {\n  position: absolute; /* ลอย */\n  top: 6.5vh;\n  left: 32vw;\n  width: 5%;\n  height: 11%;\n  color: white;\n  font-size: 3.5vw;\n  display: flex;\n  }\n\n  .B_label {\n  position: absolute; /* ลอย */\n  top: 18.5vh;\n  left: 32vw;\n  width: 5%;\n  height: 11%;\n  color: white;\n  font-size: 3.5vw;\n  display: flex;\n  }\n\n  .C_label {\n  position: absolute; /* ลอย */\n  top: 26.5vh;\n  left: 32vw;\n  width: 5%;\n  height: 11%;\n  color: white;\n  font-size: 3.5vw;\n  display: flex;\n  }\n\n  .D_label {\n  position: absolute; /* ลอย */\n  top: 38.5vh;\n  left: 32vw;\n  width: 5%;\n  height: 11%;\n  color: white;\n  font-size: 3.5vw;\n  display: flex;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
